export default "__VITE_ASSET__DKEDWnGc__"